import apiBase from "./api.base";
import Session from "supertokens-auth-react/recipe/session";
import {
  getBoundUserId,
  invalidateSessionIdentity,
  isSessionInvalidated,
  SESSION_USER_HEADER,
} from "@/lib/auth/session-identity";

const apiClient = apiBase;

apiClient.interceptors.request.use(async (config) => {
  if (isSessionInvalidated()) throw new Error("SESSION_USER_MISMATCH");
  const userId = getBoundUserId();
  if (userId) {
    if (
      !(await Session.doesSessionExist()) ||
      (await Session.getUserId()) !== userId
    ) {
      invalidateSessionIdentity();
      throw new Error("SESSION_USER_MISMATCH");
    }
    config.headers.set(SESSION_USER_HEADER, userId);
  }
  return config;
});

apiClient.interceptors.response.use(
  async (response) => {
    const expectedUserId = response.config.headers.get(SESSION_USER_HEADER);
    if (
      expectedUserId &&
      (isSessionInvalidated() ||
        getBoundUserId() !== expectedUserId ||
        !(await Session.doesSessionExist()) ||
        (await Session.getUserId()) !== expectedUserId)
    ) {
      invalidateSessionIdentity();
      throw new Error("SESSION_USER_MISMATCH");
    }
    return response;
  },
  (error) => {
    if (
      ["SESSION_USER_MISMATCH", "SESSION_COOKIE_CONFLICT"].includes(
        error.response?.data?.code,
      )
    ) {
      invalidateSessionIdentity();
    }
    return Promise.reject(error);
  },
);

export default apiClient;
